import React, {useEffect} from "react";
import {observer} from "mobx-react";
import {useTranslate} from "../../../../../../hooks/translate.hook";
import {Button, Card, Col, Form, Row, Space} from "antd";
import {AgentNewContext} from "../../agent.new.modal";
import {UIInputWidgetWarehouse} from "../../../../../common/ui/input/widget/warehouse/ui.input.widget.warehouse";
import {
    UiInputWidgetWarehousesAgreements
} from "../../../../../common/ui/input/widget/warehouses-agreements/ui.input.widget.warehouses-agreements";
import {AgreementData} from "../../../../../common/ui/input/widget/warehouses-agreements/common/model";
import {useAgentNewStepCardStyles} from "../agent.new.step.card.styles";

export const WarehousesStep: React.FC = observer(() => {

    const {setStep, setValue, getValue, fields} = React.useContext(AgentNewContext);

    const t = useTranslate();
    const cardStyles = useAgentNewStepCardStyles();

    const [form] = Form.useForm();

    useEffect(() => {
        form.setFields(fields);
    }, [fields])

    const defaultValues = {
        warehouses: getValue('warehouses') || [],
        defaultWarehouse: getValue('defaultWarehouse')
    }

    return <Space direction="vertical" size={[15, 15]} style={{width: "100%"}}>
        <Form
            size={"middle"}
            form={form}
            layout="vertical"
            initialValues={defaultValues}
            onFinish={async (values) => {
                await form.validateFields();
                setValue('warehouses', values.warehouses)
                setValue('defaultWarehouse', values.defaultWarehouse)
                setStep(2)
            }}
        >
            <Row gutter={[16, 0]} align="top">
                <Col span={24}>
                    <Form.Item name="warehouses">
                        <UiInputWidgetWarehousesAgreements />
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={[16, 0]} align="top">
                <Col xs={24} md={12}>
                    <Form.Item noStyle shouldUpdate>
                        {() => (
                            <Form.Item
                                name="defaultWarehouse"
                                label={t("CLIENT.WAREHOUSES.DEFAULT_WAREHOUSE")}
                                rules={[
                                    {
                                        required: true,
                                        message: t("FROM.ERROR.PLEASE_ENTER_VALUE"),
                                    },
                                ]}
                            >
                                <UIInputWidgetWarehouse
                                    allowedOnly={(form.getFieldValue("warehouses") || []).map(
                                        (warehouse: AgreementData) => warehouse.warehouse
                                    )}
                                    loading={(form.getFieldValue("warehouses") || []).length === 0}
                                />
                            </Form.Item>
                        )}
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={[30, 0]} align="top" style={{marginTop: 16}}>
                <Col span={24}>
                    <Space direction={"horizontal"} size={[10, 10]}>
                        <Button type={"default"} onClick={() => setStep(0)}>Back</Button>
                        <Button type={"primary"} onClick={() => form.submit()}>Next</Button>
                    </Space>
                </Col>
            </Row>
        </Form>
    </Space>
});
